/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { useMutation, useQuery } from "@tanstack/react-query";
import { addMessage, getContactUs } from "../../../lib/Services_with_Query";
import Loader from "../../../Component/Loader/Loader";
import { validationSchema } from "./Validation";
const Quote = ({ website_id, agent_id }) => {
  const mutation = useMutation({
    mutationFn: (values) => addMessage(values, website_id, agent_id),
    onSuccess: ({ status, message }) => {
      if (status === true) {
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "success",
          title: message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      }
    },
    onError: ({ response }) => {
      Swal.fire({
        showCloseButton: true,
        toast: true,
        icon: "error",
        title: response?.data?.message,
        animation: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
    },
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    mutation.mutate(values, {
      onSettled: () => {
        setSubmitting(false);
      },
      onSuccess: () => {
        resetForm();
      },
    });
  };

  const shouldFetch = website_id && agent_id ? true : false;
  const { data, isLoading } = useQuery({
    queryKey: ["getContactUs"],
    queryFn: () => getContactUs(website_id, agent_id),
    enabled: shouldFetch,
  });
  if (isLoading) return <Loader />;

  return (
    <>
      <div className="quote-area quote-area-2 quote-area-3">
        <div className="container">
          <div className="row quote-center d-flex align-items-center">
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="quote-image">
                <div className="sub-head white-head">
                  <h4>Contact us for services</h4>
                  <div className="single-contact">
                    <Link to="">
                      <i className="fa fa-phone" />
                      <span>
                        {`${
                          data?.phone_no ? `+` + data?.phone_no : "Not Found"
                        }`}
                      </span>
                    </Link>
                    <Link to="">
                      <i className="fa fa-envelope" />
                      <span>{data?.email ? data?.email : "Not Found"}</span>
                    </Link>
                    <Link to="">
                      <i className="fa fa-map" />
                      <span>
                        {data?.location ? data?.location : "Not Found"}
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7 col-md-12">
              <div className="quote-all">
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    number: "",
                    message: "",
                    lastName: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (
                    <Form id="contactForm" className="contact-form">
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6">
                          <Field
                            type="text"
                            id="name"
                            name="name"
                            className="form-control"
                            placeholder="First Name"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="error-message"
                          />
                          <Field
                            type="text"
                            id="lastName"
                            name="lastName"
                            className="form-control"
                            placeholder="Last Name"
                          />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="error-message"
                          />

                          <Field
                            type="email"
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message"
                          />
                        </div>

                        <div className="col-xl-6 col-lg-6 col-md-6">
                          <Field
                            type="textarea"
                            id="message"
                            name="message"
                            rows={3}
                            className="form-control"
                            placeholder="Message"
                          />
                          <ErrorMessage
                            name="message"
                            component="div"
                            className="error-message"
                          />

                          <Field
                            type="number"
                            id="number"
                            name="number"
                            className="form-control"
                            placeholder="Number"
                          />
                          <ErrorMessage
                            name="number"
                            component="div"
                            className="error-message"
                          />
                          <button
                            type="submit"
                            id="submit"
                            className="anti-btn quote-btn"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                          <div
                            id="msgSubmit"
                            className="h3 text-center hidden"
                          />
                          <div className="clearfix" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Quote Area */}
    </>
  );
};

export default Quote;
